/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 22/05/2022
 */

import * as React from 'react';
import useData from '@/wpt-lib/pdf/useData';
import { Table } from '@/wpt-lib/pdf/common/Table';
import Rating from '@/wpt-lib/pdf/review/Rating';
import Page from './common/Page';
import Comments from '@/wpt-lib/pdf/Comments';
import { WorkplanState } from '@/wpt-lib/interfaces/Workplan';
import MeetingDates from '@/wpt-lib/pdf/MeetingDates';
import Heading from '@/wpt-lib/pdf/common/Heading';
import StateHistory from '@/wpt-lib/pdf/review/StateHistory';
import { isNullish } from '@/wpt-lib/utils/isNullish';
import Declarations from '@/wpt-lib/pdf/Declarations';
import SupportingDocuments from '@/wpt-lib/pdf/SupportingDocuments';

const Review = () => {
    const { workplan, version, comments, workplanAttachments } = useData();

    return (
        <>
            <Page>
                <Heading text="Reviews" />

                <MeetingDates
                    planningMeetingDate={version.planningMeetingDate}
                    progressReviewMeetingDate={version.progressReviewMeetingDate}
                    endOfYearMeetingDate={version.endOfYearMeetingDate}
                />
                <SupportingDocuments workplanAttachments={workplanAttachments} />
                <Declarations {...version} />
                <Table cols={3}>
                    <Comments comments={comments.filter((c) => isNullish(c.section))} />
                </Table>

                <StateHistory />
            </Page>

            {workplan.state === WorkplanState.ENDORSED && <Rating />}
        </>
    );
};

export default Review;
